import { ErrorBoundary } from "@sentry/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setPageName } from "../../actions";
import "../../assets/styles/pages/domo.scss";
import { IframeLayout } from "../../components/Layouts";
import { LookStudioEmbeddedLinks } from "../../constants/globalMSSalesConstants";
import { ErrorMsg } from "../AppMessages";
import { IframePageContent } from "../PageContent";
import { eventTracking, MixpanelEvents } from "../../utils/userTracking";

const DomoScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);

  useEffect(() => {
    dispatch(setPageName(""));
  }, [dispatch]);

  const handleSubmitAccess = () => {
    // history.push("https://mail-nissan-co-jp.domo.com/app-studio/1715837236/pages/486395279");
    eventTracking(MixpanelEvents.dashboard_access_request);
    setIsRequestSubmitted(true);
  };

  const handleClick = () => {
    history.push("/ccs_vital_signs/domo");
    setIsRequestSubmitted(false);
  };

  return (
    <IframeLayout hasFilter={true}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {/* <iframe src="https://mail-nissan-co-jp.domo.com/embed/pages/private/oZo13" width="1248" height="1620" marginheight="0" marginwidth="0" frameborder="0"></iframe> */}
        <div className="main_dashboard_domo">
          <div className="section">
            {isRequestSubmitted ? (
              <div onClick={handleClick} className="back_button">
                &lt;
                <span className="back_text">&nbsp; Back</span>
              </div>
            ) : (
              <>
                <p>Access to the new CCS Vital Signs dashboard is managed by the CCS team. Please use the link below to request it.</p>
                <button className="googleAccountBtn" onClick={handleSubmitAccess}>
                  SUBMIT ACCESS REQUEST
                </button>
              </>
            )}
          </div>
        </div>
        {isRequestSubmitted ? (
          <IframePageContent frameId="global_ms_sales_submitdomo" iframeUrl={LookStudioEmbeddedLinks.submit_domo_url} />
        ) : (
          <IframePageContent frameId="global_ms_sales_domo" iframeUrl={LookStudioEmbeddedLinks.domoscreen_url} />
        )}
      </ErrorBoundary>
    </IframeLayout>
  );
};

export default DomoScreen;
